import { useScreenSize } from 'hooks/useScreenSize'

export const useIsMobile = (useLargeMobile?: boolean) => {
  const { isMobile: isMobileCsr, isMobileSSR, isLargeMobile } = useScreenSize()
  if (typeof isMobileCsr === 'boolean' || typeof isLargeMobile === 'boolean') {
    return Boolean(useLargeMobile ? isLargeMobile || isMobileCsr : isMobileCsr)
  }
  return Boolean(useLargeMobile ? isLargeMobile || isMobileSSR : isMobileSSR)
}
